module.exports = __webpack_public_path__ + "img/factory-4.5a98d2e1.jpg";